import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=2766c7fa&scoped=true&"
import script from "./Splash.vue?vue&type=script&lang=ts&"
export * from "./Splash.vue?vue&type=script&lang=ts&"
import style0 from "./Splash.scss?vue&type=style&index=0&id=2766c7fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766c7fa",
  null
  
)

export default component.exports